<script setup lang="ts">
import type { SettingsTab } from '@/apps/admin/components/settings/constants';

interface Props {
   tabs: SettingsTab[];
   modelValue: string;
}

interface Emits {
   (e: 'update:modelValue', value: string): void;
}

const props = defineProps<Props>();
const emit = defineEmits<Emits>();

const setActiveTab = (tabId: string) => {
   emit('update:modelValue', tabId);
};
</script>

<template>
   <div class="vertical-tabs">
      <div class="vertical-tabs-menu">
         <button
            v-for="tab in tabs"
            :key="tab.id"
            class="vertical-tabs-menu-button"
            :class="{ active: modelValue === tab.id }"
            @click="setActiveTab(tab.id)"
         >
            {{ $t(tab.i18n_key) }}
         </button>
      </div>

      <div class="vertical-tabs-content">
         <slot />
      </div>
   </div>
</template>

<style lang="scss" scoped>
.vertical-tabs {
   display: flex;
   height: 100%;
   gap: var(--nxt-gutter-large);
   padding-top: var(--nxt-gutter-large);

   .vertical-tabs-menu {
      display: flex;
      flex-direction: column;
      gap: var(--nxt-gutter-large);

      .vertical-tabs-menu-button {
         text-align: left;
         cursor: pointer;
         font-size: var(--nxt-font-xlarge);
         font-weight: var(--nxt-font-bold);
         color: var(--nxt-grey);

         &:hover,
         &.active {
            color: var(--nxt-dark);
         }
      }
   }

   .vertical-tabs-content {
      flex: 1;
   }
}
</style>
